
import {
    Chart as ChartJS,
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { Smily } from './Smily';
import { Card, Divider, Typography } from '@mui/material';
import { RollupGraphExample } from '../../../merchant/pages/RollupGraphExample';
import { Report } from '../dailyRating';


ChartJS.register(
    LinearScale,
    CategoryScale,
    BarElement,
    PointElement,
    LineElement,
    Legend,
    Tooltip,
    LineController,
    BarController
);


// const options = {
//     responsive: true,
//     interaction: {
//         mode: 'index' as const,
//         intersect: false,
//     },
//     stacked: false,

//     scales: {
//         y1: {
//             type: 'linear' as const,
//             position: 'left' as const,
//             display: true,
//             fontColor: "#7CA7E7",
//             title: {
//                 display: true,
//                 text: "Satisfaction",
//                 color: "#fffff",
//             }


//         },
//         y2: {
//             type: 'linear' as const,
//             position: 'right' as const,
//             display: true,
//             fontColor: "#7CA7E7",
//             labelString: "y2",
//             labels: "y2",
//             title: {
//                 display: true,
//                 text: "Responses",
//                 color: "#fffff",
//             }

//         },
//     },
// };




// const labels = ['January', 'February', 'March', 'April', 'May', 'June', 'July'];

// const dataObj = [
//     590,
//     868,
//     1397,
//     1480,
//     1520,
//     1400,
//     1400,
//     1400,
// ];

// export const data = {
//     labels,
//     datasets: [
//         {
//             type: 'line' as const,
//             label: 'Satisfaction',
//             borderColor: '#FD3B3B',
//             borderWidth: 2,
//             fill: false,
//             data: dataObj,
//             yAxisID: 'y1',
//         },
//         {
//             type: 'bar' as const,
//             label: 'Responses',
//             backgroundColor: '#7CA7E7',
//             data: dataObj,
//             borderColor: 'white',
//             borderWidth: 2,
//             yAxisID: 'y2',
//         },
//     ],
// };


type SatisfactionResponsesGrafProps = Readonly<{
    dailyRating: Report
}>

export function SatisfactionResponsesGraf({ dailyRating }: SatisfactionResponsesGrafProps) {

    return (
        <>
            <RollupGraphExample />

            {/* <Chart options={options} type='bar' data={data} /> */}
        </>
    )
}
